import React from "react";
import styles from "./Stepper.module.scss";

interface StepperProps {
  children: React.ReactNode;
  steps: [{ title: string, description: string }] | [] | undefined;
}

interface StepperItemProps {
  children: React.ReactNode;
  heading: string;
  type: "primary" | "secondary";
  number: number;
}

export const StepperItem = ({ children, heading, type, number }: StepperItemProps) => {
  return (
    <div className={styles.stepperSection}>
      <div className={styles.timeline}>
        <div className={styles.iconArea}>
          <div className={styles.icon}>{number}</div>
        </div>
        {type === "primary" ? <div className={styles.line} /> : <div className={styles.lineInvis} />}
      </div>
      <div className={styles.contentArea}>
        <h4 className={styles.heading}>{heading}</h4>
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
}

export const Stepper = ({ steps = [] }: StepperProps)=>{
  return steps?.length
    ? <div style={{ marginTop: "50px" }}>
      {steps.map((step, i) => (
        <StepperItem
          heading={step.title}
          number={i + 1}
          type={i + 1 === steps.length ? 'secondary' : "primary"}
        >
          {step.description}
        </StepperItem>
      ))}
    </div>
    : null
}

export default Stepper